import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import useInterval from '../../utils/useInterval';

export default function TimeFromNow({ dateTime }) {
  const [relativeTime, setRelativeTime] = useState(moment(dateTime).fromNow());

  // no need to auto refresh, if period is greater then one day
  if (moment().diff(moment(dateTime), 'days') < 1) {
    useInterval(() => {
      setRelativeTime(moment(dateTime).fromNow());
    }, 60000);
  }
  return <span>{relativeTime}</span>;
}

TimeFromNow.propTypes = {
  dateTime: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/common/TimeFromNow.jsx